import '../../assets/index5.css';var S = Object.defineProperty, v = Object.defineProperties;
var y = Object.getOwnPropertyDescriptors;
var n = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty, w = Object.prototype.propertyIsEnumerable;
var p = (o, e, d) => e in o ? S(o, e, { enumerable: !0, configurable: !0, writable: !0, value: d }) : o[e] = d, i = (o, e) => {
  for (var d in e || (e = {}))
    m.call(e, d) && p(o, d, e[d]);
  if (n)
    for (var d of n(e))
      w.call(e, d) && p(o, d, e[d]);
  return o;
}, l = (o, e) => v(o, y(e));
var _ = (o, e) => {
  var d = {};
  for (var r in o)
    m.call(o, r) && e.indexOf(r) < 0 && (d[r] = o[r]);
  if (o != null && n)
    for (var r of n(o))
      e.indexOf(r) < 0 && w.call(o, r) && (d[r] = o[r]);
  return d;
};
import { jsxs as E, jsx as a } from "react/jsx-runtime";
import { forwardRef as P, useEffect as k } from "react";
import { S as N } from "../../Stack-CTaaXTID.js";
const g = "SearchPopdown-module__dropdown___EiY-8", x = "SearchPopdown-module__dropdownOpen___mlb8e", O = "SearchPopdown-module__target___T3a8J", t = {
  dropdown: g,
  dropdownOpen: x,
  target: O
}, j = P((L, h) => {
  var s = L, {
    opened: o,
    onOpenChange: e,
    children: d,
    target: r
  } = s, f = _(s, [
    "opened",
    "onOpenChange",
    "children",
    "target"
  ]);
  return k(() => {
    const c = (u) => {
      u.key === "Escape" && o && e(!1);
    };
    return document.addEventListener("keydown", c), () => {
      document.removeEventListener("keydown", c);
    };
  }, [o, e]), /* @__PURE__ */ E("div", l(i({ className: t.container, style: { width: "100%" }, ref: h }, f), { children: [
    /* @__PURE__ */ a("div", { className: t.target, children: r }),
    /* @__PURE__ */ a("div", { className: `${t.dropdown} ${o ? t.dropdownOpen : ""}`, children: /* @__PURE__ */ a(N, { children: d }) })
  ] }));
});
j.displayName = "SearchPopdown";
export {
  j as SearchPopdown
};
